import { computed, watch } from 'vue';
import kebabCase from 'lodash/kebabCase';

export const useTabable = (props, emit, parent) => {
    const slug = computed(() => {
        return props.id || kebabCase(props.title);
    });

    const isOpen = computed(() => {
        return parent.selected === slug.value;
    });

    watch(isOpen, (n) => {
        n ? emit('open') : emit('close');
    });

    return {
        slug,
        isOpen,
    };
};
